"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELF_SERVICE_LEGACY_TEXT = exports.API_CENTRAL_LEGACY_TEXT = void 0;
var API_CENTRAL_LEGACY_TEXT = "This is a project that previously existed in our system but was not created with API Central using the manage project feature. We are sorry that we can't provide use case info at this time. If you have a question, please reach out to API Central Support.";
exports.API_CENTRAL_LEGACY_TEXT = API_CENTRAL_LEGACY_TEXT;
var SELF_SERVICE_LEGACY_TEXT = "This is a project that previously existed in our system but was not created with this self-service tool using the manage project feature. We are sorry that we can\u2019t provide use case info at this time. If you have a question, please reach out to your technical advisor.";
exports.SELF_SERVICE_LEGACY_TEXT = SELF_SERVICE_LEGACY_TEXT;